import React from "react";
import { Checkbox, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import { whatsapp } from "config";
const StyledDiv = styled.div`
  gap: 12px;
`;

const SendMode = ({
  sendMode,
  setSendMode,
  rewardType,
  currencyCode,
  clientId = "",
  recipientData = [],
  isEditUserEnabled,
}) => {
  const hideSendMode =
    (recipientData.length === 1 && !isEditUserEnabled) ||
    recipientData.length > 1;
  let SEND_MODES_DATA = [
    {
      id: "email",
      label: "Email address",
    },
    {
      id: "sms",
      label: "SMS",
    },
  ];
  if (
    (rewardType === 1 || rewardType === 2) &&
    SEND_MODES_DATA.filter((data) => data.id === "whatsapp").length === 0 &&
    whatsapp?.currency_code.includes(currencyCode) &&
    ((whatsapp?.client_ids || []).length
      ? whatsapp?.client_ids.includes(clientId)
      : true)
  ) {
    SEND_MODES_DATA = [
      ...SEND_MODES_DATA,
      {
        id: "whatsapp",
        label: "Whatsapp",
      },
    ];
  }
  if (hideSendMode) return "";
  return (
    <StyledDiv className="d-flex align-items-center px-24 py-12">
      <Typography.HelperText color="dark" shade="c200">
        Send via
      </Typography.HelperText>
      {SEND_MODES_DATA.map((item, index) => {
        const isChecked = sendMode?.includes(item.id);

        return (
          <Checkbox
            key={index}
            label={item.label}
            onChange={() => {
              setSendMode((prevSendMode) =>
                isChecked
                  ? prevSendMode.filter((id) => id !== item.id)
                  : [...prevSendMode, item.id]
              );
            }}
            value={item.id}
            className="mb-0"
            checked={isChecked}
            disabled={isChecked && sendMode?.length === 1}
          />
        );
      })}
    </StyledDiv>
  );
};

export default SendMode;
